import { IRuntimeBridgeClient } from './IRuntimeBridgeClient';

/**
 * Native application implementation of the Runtime Bridge Client.
 * Communicates directly with the native runtime via window.jsBridgeRuntime
 */
export default class NativeRuntimeBridgeClient implements IRuntimeBridgeClient {
    private jsBridgeRuntime: any;

    constructor() {
        this.jsBridgeRuntime = (window as any).jsBridgeRuntime;
    }

    /**
     * Uploads a response file using the native runtime
     * @param filename - Name of the file to upload
     * @param apiUrl - API URL to use for the response upload
     */
    public uploadResponse(filename: string, apiUrl: string): void {
        this.jsBridgeRuntime.uploadResponse(filename, apiUrl);
    }

    /**
     * Starts screen recording using the native runtime
     */
    public startScreenRecording(): void {
        this.jsBridgeRuntime.startScreenRecording();
    }

    /**
     * Stops screen recording using the native runtime
     */
    public stopScreenRecording(): void {
        this.jsBridgeRuntime.stopScreenRecording();
    }

    /**
     * Quits the application via the native runtime
     */
    public quit(): void {
        this.jsBridgeRuntime.quit();
    }

    /**
     * Checks if the application is online using the native runtime
     * @returns True if online, false otherwise
     */
    public isOnline(): boolean {
        return this.jsBridgeRuntime.isOnline();
    }

    /**
     * Checks if the application is running on Windows using the native runtime
     * @returns True if running on Windows, false otherwise
     */
    public isWindows(): boolean {
        return this.jsBridgeRuntime.isWindows();
    }

    /**
     * Gets the media URL from the native runtime
     * @returns Media URL as a string
     */
    public getMediaUrl(): string {
        return this.jsBridgeRuntime.getMediaUrl();
    }

    /**
     * Lists the available keyboard languages via the native runtime
     * @returns An array of available keyboard language codes
     */
    public listKeyboardLanguagesAvailable(): string[] {
        return this.jsBridgeRuntime.listKeyboardLanguagesAvailable();
    }

    /**
     * Sets the runtime language via the native runtime
     * @param lang - Language code to set as the runtime language
     */
    public setRuntimeLanguage(lang: string): void {
        this.jsBridgeRuntime.setRuntimeLanguage(lang);
    }

    /**
     * Notifies the native runtime that the frontend is ready
     */
    public frontendReady(): void {
        this.jsBridgeRuntime.frontendReady();
    }

    /**
     * Changes the keyboard language via the native runtime
     * @param lang - Language code to change the keyboard to
     */
    public changeKeyboardLanguage(lang: string): void {
        this.jsBridgeRuntime.changeKeyboardLanguage(lang);
    }
}
